import type { SchoolSeatsOverviewResponse } from '@kimuno/api-sdk/lib/types/responses/Teacher';

import { schoolLicences } from '../constants';

/**
 * Builds subscription products array based on available school seats
 * @param schoolSeats - The school seats data
 * @returns Array of subscription product names
 */
export const buildAmpliSubscriptionProducts = (
	schoolSeats: SchoolSeatsOverviewResponse
): string[] => {
	const subscriptionProducts: string[] = [];

	if (schoolSeats.bibliothekSeats?.available > 0) {
		const muProModel = schoolLicences.models.find((m) => m.id === schoolLicences.MU_PRO);
		if (muProModel?.ampliName) {
			subscriptionProducts.push(muProModel.ampliName);
		}
	}

	if (schoolSeats.courseSeats?.available > 0) {
		const courseModel = schoolLicences.models.find((m) => m.id === schoolLicences.COURSE);
		if (courseModel?.ampliName) {
			subscriptionProducts.push(courseModel.ampliName);
		}
	}

	if (schoolSeats.kombiSeats?.available > 0) {
		const kombiModel = schoolLicences.models.find((m) => m.id === schoolLicences.KOMBI);
		if (kombiModel?.ampliName) {
			subscriptionProducts.push(kombiModel.ampliName);
		}
	}

	return subscriptionProducts;
};
